export const salaryFrequencyList = [
    {
        id: '1',
        title: 'Per year',
    },
    {
        id: '2',
        title: 'Per month',
    },
    {
        id: '3',
        title: 'Per hour',
    },
];

export const workplaceTypeList = [
    {
        id: '1',
        title: 'On site',
    },
    {
        id: '2',
        title: 'Hybrid',
    },
    {
        id: '3',
        title: 'Remote',
    },
];

export const jobTypeList = [
    {
        id: '1',
        title: 'Full time',
    },
    {
        id: '2',
        title: 'Part time',
    },
    {
        id: '3',
        title: 'Contract',
    },
    {
        id: '4',
        title: 'Temporary',
    },
    {
        id: '5',
        title: 'Other',
    },
    {
        id: '6',
        title: 'Volunteer',
    },
    {
        id: '7',
        title: 'Internship',
    },
];

export const codingLanguagesList = [
    {
        id: 'c',
        title: 'C'
    },
    {
        id: 'cpp',
        title: 'C++'
    },
    {
        id: 'csharp',
        title: 'C#'
    },
    {
        id: 'rust',
        title: 'Rust'
    },
    {
        id: 'java',
        title: 'Java'
    },
    {
        id: 'r',
        title: 'R'
    },
    {
        id: 'go',
        title: 'Go'
    },
    {
        id: 'python',
        title: 'Python'
    },
    {
        id: 'javascript',
        title: 'Java Script'
    },
    {
        id: 'typescript',
        title: 'Type Script'
    },
    {
        id: 'swift',
        title: 'Swift'
    },
    {
        id: 'php',
        title: 'PHP'
    },
    {
        id: 'scala',
        title: 'Scala'
    },
    {
        id: 'kotlin',
        title: 'Kotlin'
    },
    {
        id: 'ruby',
        title: 'Ruby'
    },
]